import { render, staticRenderFns } from "./deleted.vue?vue&type=template&id=20a80f23&scoped=true"
import script from "./deleted.vue?vue&type=script&lang=js"
export * from "./deleted.vue?vue&type=script&lang=js"
import style0 from "./deleted.vue?vue&type=style&index=0&id=20a80f23&prod&scoped=true&lang=scss"
import style1 from "./deleted.vue?vue&type=style&index=1&id=20a80f23&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a80f23",
  null
  
)

export default component.exports